const Popper = (props) => {
  return (
      <div className={'popperText'}>
        {props.children}
        {props.title &&
            <strong style={{fontSize: 'var(--fz-xxs)'}} className={'popperDown whitespace-nowrap bg-amber-500 mt-0 py-1 px-2 rounded text-black'}>
              {props.title}
            </strong>
        }

      </div>
  )
};

export default Popper;
